import i18n from 'src/utils/translate';
import ButtonDropdown from 'src/components/buttons/buttonDropdown/buttonDropdown';
import FollowButton from 'src/components/buttons/followButton';
import { useDispatch, useSelector } from 'react-redux';
import { State } from 'src/types';
import { userIsMemberOfCurrentGroup } from 'src/utils/context';
import Button from 'src/components/buttons/button';
import { showModal } from 'src/modules/shared/modal/actions';
import ModalType from 'src/constants/modalTypes';

export default function AdminActions() {
  const { currentCommunity, currentUser } = useSelector((state: State) => state.context);
  const isMemberOfCommunity = userIsMemberOfCurrentGroup(currentUser, currentCommunity);
  const dispatch = useDispatch();

  // As we're not using DropdownItem (from reactstrap) in this dropdown, we need
  // to add tabindex & role manually for the 2 buttons to be navigable by keyboard
  return (
    <ButtonDropdown text={i18n.t('More')}>
      <FollowButton
        buttonType="link"
        className="dropdown-item"
        community={currentCommunity}
        followType="group"
        isActive={!!currentUser}
        isFollowing={isMemberOfCommunity}
        noIcon={true}
        role="menuitem"
        tabIndex="0"
        user={currentUser}
      />
      <Button
        className="dropdown-item"
        icon="cog"
        iconLeftAligned={false}
        role="menuitem"
        tabIndex="0"
        type="link"
        onClick={() => dispatch(showModal({ modalType: ModalType.COMMUNITY_INVITES }))}
      >
        {i18n.t('Invite')}
      </Button>
    </ButtonDropdown>
  );
}
